export default __webpack_public_path__ + "5ff4e6244d21284a3b0911893bfe6aa9.svg";